<main class="content">
  <section class="page-shell">
    <header class="page-header">
      <h2>Centro de Notificaciones</h2>
      <p>Mantente al día con las notificaciones personales más relevantes sobre tus postulaciones y participaciones.</p>
    </header>

    <div class="tabs" role="tablist" aria-label="Estado de lectura">
      <button
        type="button"
        role="tab"
        class="tab-button"
        [class.tab-active]="estadoLecturaFiltro === 'todas'"
        (click)="cambiarEstadoLectura('todas')">
        Todas
      </button>
      <button
        type="button"
        role="tab"
        class="tab-button"
        [class.tab-active]="estadoLecturaFiltro === 'no_leidas'"
        (click)="cambiarEstadoLectura('no_leidas')">
        No leídas
      </button>
      <button
        type="button"
        role="tab"
        class="tab-button"
        [class.tab-active]="estadoLecturaFiltro === 'leidas'"
        (click)="cambiarEstadoLectura('leidas')">
        Leídas
      </button>
    </div>

    <div class="notifications-list-wrap" *ngIf="notificacionesPaginadas.length > 0; else sinNovedades">
      <ul class="novedades-list">
        <li
          *ngFor="let novedad of notificacionesPaginadas"
          class="novedad-card"
          [class.novedad-card-unread]="!novedad.leida"
          [class.novedad-card-read]="novedad.leida">
          
          <!-- Top Row: Date only -->
          <div class="card-top-row">
            <span class="date-stamp">{{ formatoFecha(novedad.fecha) }}</span>
          </div>

          <!-- Middle Row: Left texts & Right action -->
          <div class="card-middle-row">
            <div class="card-texts-col">
              <div class="card-title-line">
                <span class="blue-dot" *ngIf="!novedad.leida" aria-label="No leída"></span>
                <h3 class="novedad-title">{{ novedad.titulo }}</h3>
              </div>
              <p class="novedad-desc">{{ detalleNovedad(novedad) }}</p>
            </div>

            <!-- Action Ver detalles on the RIGHT -->
            <button
              type="button"
              class="btn-detail-action"
              (click)="abrirDetalle(novedad)">
              Ver detalles <span class="plus-icon" aria-hidden="true">⊕</span>
            </button>
          </div>

          <!-- Bottom Row: Chip on the LEFT -->
          <div class="card-bottom-row">
            <span
              class="chip-status"
              [class.chip-unread]="!novedad.leida"
              [class.chip-read]="novedad.leida">
              {{ novedad.leida ? 'Leída' : 'No leída' }}
            </span>
          </div>
        </li>
      </ul>

      <!-- Numeric pagination matching Figma -->
      <nav class="numeric-pagination" *ngIf="totalPaginas > 1" aria-label="Paginación de notificaciones">
        <button
          type="button"
          class="page-nav-btn"
          (click)="cambiarPagina(paginaActual - 1)"
          *ngIf="paginaActual > 1"
          aria-label="Página anterior">
          &lt;
        </button>
        <button
          *ngFor="let p of paginasArray"
          type="button"
          class="page-num-btn"
          [class.page-active]="p === paginaActual"
          (click)="cambiarPagina(p)"
          [attr.aria-current]="p === paginaActual ? 'page' : null">
          {{ p }}
        </button>
        <button
          type="button"
          class="page-nav-btn"
          (click)="cambiarPagina(paginaActual + 1)"
          [disabled]="paginaActual === totalPaginas"
          aria-label="Página siguiente">
          &gt;
        </button>
      </nav>
    </div>

    <ng-template #sinNovedades>
      <div class="empty">
        <span class="empty-icon">
          <lucide-angular name="bell" aria-hidden="true"></lucide-angular>
        </span>
        <strong>No hay notificaciones disponibles</strong>
        <p>Revisa el estado seleccionado o actualiza la información.</p>
      </div>
    </ng-template>
  </section>
</main>
